import type { Route } from './+types/root';

// Note: Translations for meta tags are handled dynamically in app-layout.tsx
export const meta: Route.MetaFunction = () => {
  return [
    { title: 'imaginame.io - AI-Powered Domain Name Generator' }, // Default title
    {
      name: 'description',
      content:
        'Discover perfect domain names for your project with imaginame.io, an AI-powered domain generator that creates unique, memorable, and available domain suggestions.', // Default description
    },
    // Add other static meta tags here if needed
    {
      property: 'og:title',
      content: 'imaginame.io - AI-Powered Domain Name Generator',
    },
    {
      property: 'og:description',
      content:
        'Discover perfect domain names for your project with imaginame.io, an AI-powered domain generator that creates unique, memorable, and available domain suggestions.',
    },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://imaginame.io' },
    { name: 'twitter:card', content: 'summary_large_image' },
    {
      name: 'twitter:title',
      content: 'imaginame.io - AI-Powered Domain Name Generator',
    },
    {
      name: 'twitter:description',
      content:
        'Discover perfect domain names for your project with imaginame.io, an AI-powered domain generator that creates unique, memorable, and available domain suggestions.',
    },
    {
      name: 'keywords',
      content:
        'domain name generator, AI domain names, domain suggestions, available domains, business name generator, brand name ideas', // Default keywords
    },
    {
      name: 'apple-mobile-web-app-title',
      content: 'imaginame.io',
    },
  ];
};
